import { useEffect } from "react";
import { useState } from "react"

export default function CountdownTimer({onComplete,timeFormatter,startFrom}){
    const [time,setTime]=useState(startFrom);
    let timer;
    const updateTime=()=>{
        timer=!timer&&setInterval(() => {
            if(time>=0){
                setTime((pre)=>{
                    return pre-1;
                })
            }else{
                onComplete();
                clearInterval(timer);
            }
          

        }, 1000);
    }
    useEffect(() => {
        updateTime();

    }, []);
    useEffect(() => {
      if(time<=0){
        onComplete(time);
        clearInterval(timer);
      }
   
    }, [time])
    
    

    return(
    <>
        {timeFormatter(time)}
    </>    )

}